import * as THREE from 'three';
import transformCubePointsToVertices from './transformCubePointsToVertices';


const CreateCubeFromPolygon = (cubePoints) => {
    // Create an empty BufferGeometry
    const geometry = new THREE.BufferGeometry();

    // Flatten the cubePoints array for BufferAttribute
    const vertices = transformCubePointsToVertices(cubePoints);

    // Create vertices position attribute
    geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));

    const indices = [
        0,
        1,
        2,
        0,
        2,
        3, // front
        4,
        5,
        6,
        4,
        6,
        7, // back
        8,
        9,
        10,
        8,
        10,
        11, // top
        12,
        13,
        14,
        12,
        14,
        15, // bottom
        16,
        17,
        18,
        16,
        18,
        19, // right
        20,
        21,
        22,
        20,
        22,
        23, // left
    ];


    geometry.setIndex(indices);

    // Optionally compute normals if your material responds to lighting
    geometry.computeVertexNormals();
    geometry.computeBoundingBox();


    // const cube = new THREE.Mesh(geometry, material);
    // cube.receiveShadow = true;

    // Assuming the cubePoints are ordered and represent a cube with axis-aligned faces
    // UV mapping for a cube where each face's UVs go from 0 to 1
    const uvs = new Float32Array([
        // Front face
        0, 0,
        1, 0,
        1, 1,
        0, 1,

        // Back face
        0, 0,
        1, 0,
        1, 1,
        0, 1,

        // Top face
        0, 0,
        1, 0,
        1, 1,
        0, 1,

        // Bottom face
        0, 0,
        1, 0,
        1, 1,
        0, 1,

        // Right face
        0, 0,
        1, 0,
        1, 1,
        0, 1,

        // Left face
        0, 0,
        1, 0,
        1, 1,
        0, 1,
    ]);

    // Add UV attribute to geometry
    geometry.setAttribute('uv', new THREE.BufferAttribute(uvs, 2));


    return geometry;
}

export default CreateCubeFromPolygon; 